import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';


import { PatientDataState } from '../state';
import { PatientData } from '@ispm-shared/modules/patient';

const getError = (state: PatientDataState): any => state.error;

const getPatientData = (state: PatientDataState): any => state.patient;

export const selectPatientDataState: MemoizedSelector<
  object,
  PatientDataState
  > = createFeatureSelector<PatientDataState>('PatientData');

export const selectPatientDataError: MemoizedSelector<object, any> = createSelector(
  selectPatientDataState,
  getError
);

export const selectPatientDataPatientData: MemoizedSelector<
  object,
  PatientData
  > = createSelector(selectPatientDataState, getPatientData);
